import React from 'react';
import 'animate.css';
import { FaPython, FaReact, FaNodeJs, FaJava } from 'react-icons/fa';
import { SiJavascript, SiMongodb, SiMysql, SiFlutter, SiFirebase } from 'react-icons/si';

const skills = [
  { name: 'Java', icon: <FaJava size={50} color="#007396" /> },
  { name: 'JavaScript', icon: <SiJavascript size={50} color="#F7DF1E" /> },
  { name: 'ReactJS', icon: <FaReact size={50} color="#61DAFB" /> },
  { name: 'NodeJS', icon: <FaNodeJs size={50} color="#339933" /> },
  { name: 'SQL', icon: <SiMysql size={50} color="#4479A1" /> },
  { name: 'MongoDB', icon: <SiMongodb size={50} color="#47A248" /> },
  { name: 'Python', icon: <FaPython size={50} color="#3776AB" /> },
  { name: 'Flutter', icon: <SiFlutter size={50} color="#02569B" /> },
  { name: 'Firebase', icon: <SiFirebase size={50} color="#FFCA28" /> },
];

const Skills = () => {
  return (
    <section id='skills'>
      <div className="min-h-screen bg-gray-900 text-white p-8">
        <h2 className="relative text-3xl font-bold text-center mb-8 animate__animated animate__fadeInDown">
          <span className="relative inline-block">
            My Skills
            <div className='h-2'></div>
            <span className="absolute bottom-0 left-0 w-full h-1 bg-transparent">
              <span className="absolute bottom-0 left-0 w-full h-full bg-blue-400 animate-drawLine"></span>
            </span>
          </span>
        </h2>
        
        <div className="gap-10 ml-0 mr-0 flex flex-wrap md:gap-40 md:ml-48 md:mr-48 justify-center items-center">
          {skills.map((skill, index) => (
            <div
              key={skill.name}
              className={`flex flex-col items-center p-6 bg-gray-800 rounded-lg shadow-lg animate__animated animate__fadeInLeft animate__delay-${index}s hover:scale-110 transition-transform duration-300`}
              style={{ width: '200px' }}
            >
              <div className="mb-4">
                {skill.icon}
              </div>
              <p className="text-lg font-bold">{skill.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;